import { FC } from 'react';
import { Badge, BadgeProps, Tooltip } from '@chakra-ui/react';

import { PiiStatus } from '../../graphql/generated';
import { StatusConfig } from './file-status-badge';

type PiiStatusBadgeProps = BadgeProps & {
  piiStatus: PiiStatus;
};

export const PiiStatusMap: Record<string, StatusConfig> = {
  [PiiStatus.AWAITING_APPROVAL]: {
    label: 'Quarantined',
    colorScheme: 'red',
    tooltip:
      'Awaiting approval. File contains Personally Identifiable Information.',
  },
};

export const shouldDisplayBadgeForPiiStatus = (status: PiiStatus): boolean =>
  Object.keys(PiiStatusMap).includes(status) || false;

export const PiiStatusBadge: FC<PiiStatusBadgeProps> = ({
  piiStatus,
  ...rest
}) => {
  const statusMap = PiiStatusMap[piiStatus];
  return (
    <Tooltip label={statusMap.tooltip}>
      <Badge variant="outline" colorScheme={statusMap.colorScheme} {...rest}>
        {statusMap.label}
      </Badge>
    </Tooltip>
  );
};
